import React from 'react';

export const Logo = ({ className = "w-10 h-10" }) => {
  return (
    <img
      src="https://i.postimg.cc/MZR5Z0KB/logo-opensyne.png"
      alt="Open Syne"
      className={`${className} object-contain`}
    />
  );
};